// extracted by mini-css-extract-plugin
export default {"planet":"PlanetItem_planet__3rS8F"};